
import { mapState } from "vuex";
import OrderBarcode from "./order-barcode.vue";
import orderDetailsItemDetailsRow from "./order-details-item-details-row.vue";
import OrderDetailsPriceBreakup from "./order-details-price-breakup.vue";

export default {
  components: {
    orderDetailsItemDetailsRow,
    OrderBarcode,
    OrderDetailsPriceBreakup
  },
  props: {
    isModificationEnabled: {
      type: Boolean,
      default: false
    },
    unavailableItems: {
      type: Array,
      default: () => []
    },
    itemOutOfStockLoading: {
      type: Boolean,
      default: false
    },
    isUpdateAndNotifyButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      combos: []
    };
  },
  beforeMount() {
    this.combos = this.getCombosFromItemsList(this.orderDetails.items);
  },
  computed: {
    ...mapState("reciever", ["orderDetails"])
  },
  methods: {
    handleCancelButton() {
      this.$emit("hide-availibility-toggle");
      this.$nuxt.$emit("availability-toggled-on");
    },
    handleModification() {
      this.$emit("modify-and-inform-customer");
    }
  }
};
